export interface StreakActions {
  /** «Забрать» в окне серии (I2). */
  claimStreak(): void;
}

const noop = () => {};

export const defaults: StreakActions = {
  claimStreak: noop,
};

declare module "../actions" {
  interface WindowActions extends StreakActions {}
}
